import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import CommonTable from '../../common/table/CommonTable';
import PropTypes from 'prop-types';

const MACHINE_TABLE_CONFIG = [
  {
    header: <FormattedMessage id="page.machines.table.header.name" defaultMessage="Name" />,
    value: machine => machine.Name,
  },
  {
    header: <FormattedMessage id="page.machines.table.header.version" defaultMessage="Version" />,
    value: machine => machine.Version,
  }, {
    header: <FormattedMessage id="page.machines.table.header.computer.name" defaultMessage="Computer name" />,
    value: machine => machine.ComputerName,
  },
  {
    header: 'MACHINE ID',
    value: machine => machine.Id,
  },
  {
    header: <FormattedMessage id="page.machines.table.header.last.connected"
                              defaultMessage="Last connected" />,
    value: machine => formatTimestampAsDateWithTime(machine.LastConnection)
    ,
  }, {
    header: <FormattedMessage id="page.machines.table.header.integration" defaultMessage="Integration" />,
    value: 'TODO',
  }, {
    header: <FormattedMessage id="page.machines.table.header.fetch"
                              defaultMessage="Fetch from dinkassa.se (1)" />,
    value: 'TODO',
  }, {
    header: <FormattedMessage id="page.machines.table.header.clear" defaultMessage="Clear dinkassa.se (2)" />,
    value: 'TODO',
  },
];

const MachinesTable = ({ machines }) => {
  
  return (
    <>
      
      <CommonTable
        data={machines}
        title={<FormattedMessage
          id="page.machines.table.title"
          defaultMessage="Cash registers"
        />}
        footerContent={
          <>
            (1) <FormattedMessage id="page.machines.table.sync.definition"
                                  defaultMessage="Synchronize items from dinkassa.se to the checkout" />
            <br />
            (2) <FormattedMessage id="page.machines.table.clear.definition"
                                  defaultMessage="Remove all objects on the dinkassa.se page (does not apply to transactions, invoices, etc.). This will start a resynchronization from the checkout to dinkassa.se"
          />
          </>}
        tableConfig={MACHINE_TABLE_CONFIG}
      />

    </>
  );
};

MachinesTable.propTypes = {
  machines: PropTypes.array,
};

const decorate = compose(
  connect(
    store => ({ machines: store.user.machines }),
  ),
);

export default decorate(MachinesTable);